import React, { createContext, useContext, useEffect, useState } from 'react';

const ThemeContext = createContext({ theme: 'light', toggle: () => {} });

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(() => {
    try {
      // 1. Explicit user choice wins on every device.
      const stored = localStorage.getItem('tgmart_theme');
      if (stored === 'light' || stored === 'dark') return stored;
      // 2. Mobile viewports (<768px) default to LIGHT regardless of the OS
      //    `prefers-color-scheme` because most Android/iOS phones ship with
      //    system dark mode on, but the marketplace's product cards, vendor
      //    logos and OG images are tuned for light backgrounds. Users can
      //    still flip to dark via the header toggle — that choice persists.
      const isMobile = typeof window !== 'undefined' && window.matchMedia('(max-width: 767px)').matches;
      if (isMobile) return 'light';
      // 3. Desktop / tablet → respect the OS preference as before.
      return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
    } catch { return 'light'; }
  });

  useEffect(() => {
    const root = document.documentElement;
    if (theme === 'dark') root.classList.add('dark');
    else root.classList.remove('dark');
    try { localStorage.setItem('tgmart_theme', theme); } catch (err) { console.warn('ThemeContext: localStorage write failed', err); }
  }, [theme]);

  const value = { theme, toggle: () => setTheme((t) => (t === 'dark' ? 'light' : 'dark')) };
  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
};

export const useTheme = () => useContext(ThemeContext);
